import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../../components/tables/tableContext/TableContext";
import { BinHistoryDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../../../utils/dateAndTime";

export const binHistoryTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "SN Bin",
    value: "sn_bin",
    minW: 125,
  },
  {
    label: "Nr. CMR",
    value: "nr_cmr",
    minW: 125,
  },
  {
    label: "Adresa ridicare",
    value: "adresa_ridicare",
    minW: 125,
  },
  {
    label: "Punct ridicare",
    value: "punct_ridicare",
    minW: 125,
  },
  {
    label: "Nod preluare",
    value: "nod_preluare",
    minW: 125,
  },

  {
    label: "Nod destinatie",
    value: "nod_destinatie",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
  },
  {
    label: "Data crearii",
    value: "data_operatie",
    minW: 125,
  },
];

export const getBinTableData = (data: BinHistoryDataInterface[]): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_bin,
      crudData: item,
      data: [
        {
          title: item.sn_bin,
        },
        {
          title: item.nr_cmr,
        },
        {
          title: item.adresa_ridicare,
        },
        {
          title: item.punct_ridicare,
        },
        {
          title: item.nod_preluare,
        },
        {
          title: item.nod_destinatie,
        },
        {
          badges: [
            {
              badgeText: item.denumireStatus ?? "-",
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.data_operatie
                ? getDateAndTime(item.data_operatie)
                : "-",
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
